module.exports = __webpack_public_path__ + "static/OpenCL_Logo-e13abe390ecfceca2a13b5177aa15084.svg";